import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerifiedGuard  {
  constructor(
    private authService: AuthService ,
    private router: Router,

  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    return this.checkVerifiedStatus();
  }

  checkVerifiedStatus(): boolean {
    if (this.authService.checkEmailVerifiedStatus()) { return true; }

    // Navigate to the login page with extras
    this.router.navigate(['/auth/not-verified']);
    return false;
  }
}
